module.exports = __webpack_public_path__ + "img/渔业.11c1d00e.png";